export type TChatState = {
    isOpen: boolean,
    isLoaded: boolean,
}

export const initialState: TChatState = {
    isOpen: false,
    isLoaded: false,
};
